import React from "react";
import Filter from '../../../components/CRM/Filter';
import ReferenceInput from "../../../components/CRM/ReferenceInput";
import TextInput from "../../../components/CRM/TextInput";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import AutoComplete from "material-ui/AutoComplete";
import DateInput from "../../../components/CRM/DateInput";

const CustomerFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.customers.search" source="first_name_like" />
    <TextInput
      label="resources.customers.filter_last_name"
      source="last_name_like"
    />

    <ReferenceInput
      label="resources.stores.name"
      source="kiosk_id"
      reference="kiosks"
      sort={{field: "name", order: "ASC"}}
      allowEmpty={false}
      filterToQuery={name => ({name_like: name})}
    >
      <AutocompleteInput
        optionText="name"
        options={{filter: AutoComplete.caseInsensitiveFilter}}
        isFilter={true}
      />
    </ReferenceInput>

    <TextInput label="resources.customers.fields.email" source="email_like" />
    <TextInput label="resources.customers.fields.phone" source="phone_like" />

    <DateInput
      label="resources.customers.fields.createdAt"
      source="created_at_on_date"
    />
    <DateInput
      label="resources.customers.fields.updatedAt"
      source="updated_at_on_date"
    />
  </Filter>
);

export default CustomerFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Customers/CustomerFilter.js